import React from 'react';
import PropTypes from 'prop-types';
import DiscountCodesListFilters from './DiscountCodesListFilters';
import DeleteAction from 'components/field/DropDownActionsMenu/DeleteAction';
import DropDownActionsMenu from 'components/field/DropDownActionsMenu/DropDownActionsMenu';
import EditAction from 'components/field/DropDownActionsMenu/EditAction';
import ResourceList from 'components/list/Container/ResourceList';
import Table from 'components/table/Table';
import TextField from 'components/field/TextField';
import listQueryFilter from 'components/hoc/listQueryFilter';
import { deleteDiscountCode } from 'store/actions/discountCodes/deleteDiscountCodes';
import { fetchDiscountCodes } from 'store/actions/discountCodes/fetchDiscountCodes';
import theme from 'theme/theme';
import ComputedPriceField from 'components/field/ComputedPriceField';
import DateUTCField from 'components/field/DateFields/DateUTCField';
import CustomDiscountValueField from './CustomDiscountValueField';

const DiscountsCodesList = (props) => {
    const {
        actionType,
        location,
        resource,
        updateQuery,
    } = props;

    return (
        <div>
            <DiscountCodesListFilters
                actionType={ actionType }
                location={ location }
                resource={ resource }
                updateQuery={ updateQuery }
            />

            <ResourceList
                action={ fetchDiscountCodes }
                actionType={ actionType }
                location={ location }
                resource={ resource }
                updateQuery={ updateQuery }
            >
                <Table
                    colorToggle={ {
                        condition: false,
                        color: theme.palette.gray,
                        key: 'is_enabled',
                    } }
                >
                    <TextField
                        { ...props }
                        column={ {
                            link: false,
                            sortable: false,
                        } }
                        source='token'
                        label='resources.discount_codes.fields.token'
                    />

                    <TextField
                        { ...props }
                        column={ {
                            link: false,
                            sortable: false,
                        } }
                        source='status'
                        label='resources.discount_codes.fields.status'
                    />

                    <TextField
                        { ...props }
                        column={ {
                            link: false,
                            sortable: false,
                        } }
                        source='type'
                        label='resources.discount_codes.fields.type'
                    />

                    <CustomDiscountValueField
                        column={ {
                            link: false,
                            sortable: false,
                        } }
                        label='resources.orders.show.activities.booking.table.property'
                    />

                    <ComputedPriceField
                        column={ {
                            link: false,
                            sortable: false,
                        } }
                        label='resources.discount_codes.fields.amount_used'
                        source='amount_used'
                    />

                    <DateUTCField
                        column={ {
                            link: false,
                            sortable: false,
                        } }
                        label='resources.discount_codes.fields.last_used_at'
                        source='last_used_at'
                    />

                    <DropDownActionsMenu
                        column={ {
                            align: 'center',
                            link: false,
                            width: '10%',
                        } }
                        source='actions'
                    >
                        <EditAction />

                        <DeleteAction action={ deleteDiscountCode } />
                    </DropDownActionsMenu>
                </Table>
            </ResourceList>
        </div>
    );
};

DiscountsCodesList.propTypes = {
    actionType: PropTypes.string.isRequired,
    location: PropTypes.object,
    resource: PropTypes.string.isRequired,
    translate: PropTypes.func.isRequired,
    updateQuery: PropTypes.func.isRequired,
};

export default listQueryFilter(DiscountsCodesList);



// WEBPACK FOOTER //
// ./src/pages/discountCodes/list/DiscountCodesList.js